import { type PersonRole } from './person';

export enum CompetitionStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',  
};

export interface CompetitionStatusRequest {
    status: CompetitionStatus;
}

export interface Prize {
    id: string;
    name: string;
    description: string;
}

export type Sponsor = {
    id: string;
    logo: string;
    name: string;
    url: string;
}

export type BoostAllocation = {
    type: PersonRole;
    points: number;
}

export interface StartAndEnd {
    start: string;
    end: string;
}

export interface Round extends StartAndEnd {
    id: string;
    name: string;
    guestVoting: boolean;
}

export type CompetitionSummary = {
    id: string;
    status: CompetitionStatus;
    name: string;
    schedule?: Array<Round>;                    // stored as JSON in the database
    allowGuests?: boolean;
}

export interface Competition extends CompetitionSummary {
    description?: string,
    favorite?: string,                          // ID of "starred" asset
    boostAllocations?: Array<BoostAllocation>;  // stored as JSON in the database
    prizes?: Array<Prize>;                      // stored as JSON in the database
    rules?: string;
    sponsors?: Array<Sponsor>;                  // stored as JSON in the database
    creator: string;
    created: string;                            // created date in ISO8601 format
    updated: string;                            // updated date in ISO8601 format
}

export type CompetitionList = Array<Competition>;
